import { useGetCurrentStudentPerformanceQuery } from 'src/api/endpoints/students/personal/api';
import { StudentLayout } from 'src/components/Layout/student/StudentLayout';
import { formatMaterialName } from 'src/api/endpoints/materials';
import { FC, ReactElement, useLayoutEffect, useRef, useState } from 'react';
import useDateFormatter from 'src/hooks/useDateFormatter';
import { getTime } from 'src/utils/date/getTime';
import { classNames } from 'primereact/utils';
import { Helmet } from 'react-helmet-async';
import Loader from 'src/components/Loader';
import { Button } from 'primereact/button';
import { Link } from 'react-router-dom';
import './IndexPage.scss';
import { map } from 'lodash';
import { AuthorizedUserProps } from 'src/routes/components/PrivateRoute';

export const IndexPage: FC<AuthorizedUserProps> = (
    props: AuthorizedUserProps
): ReactElement => {
    // state and ref
    const [addLineFeed, setAddLineFeed] = useState(false);
    const progressContainerRef = useRef<HTMLDivElement>(null);

    // hooks
    const _ = useDateFormatter();

    const { data: performance, isLoading: isPerformanceLoading } =
        useGetCurrentStudentPerformanceQuery();

    useLayoutEffect(() => {
        function updateSize() {
            if (window.innerWidth <= 430) {
                setAddLineFeed(true);
            } else {
                setAddLineFeed(false);
            }
        }

        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    return (
        <StudentLayout auth={props}>
            <Helmet title={'Главная'} />
            {isPerformanceLoading || !performance ? (
                <Loader />
            ) : (
                <>
                    <div className="grid">
                        <div className="lg:col-5 col-12 card py-0">
                            <div className="header flex align-items-center justify-content-between points-bg">
                                <div className="title">Успеваемость</div>
                                <Link to="/progress/">
                                    <Button
                                        icon="pi pi-chevron-right white"
                                        className="p-button-rounded p-button-outlined"
                                    />
                                </Link>
                            </div>
                            <div className="content" ref={progressContainerRef}>
                                <div
                                    className="area bg"
                                    style={{ height: '137.117px' }}
                                >
                                    <div className="title points-text">
                                        Средний балл
                                    </div>
                                    <div className="flex align-items-end text">
                                        <div className="points-text h1 border">
                                            {performance.marks.average.current.toFixed(
                                                1
                                            )}
                                        </div>
                                        {map(
                                            performance.marks.average.previous,
                                            (point, idx) => (
                                                <div
                                                    className={`h${idx + 2 > 3 ? 3 : idx + 2} border`}
                                                    key={point}
                                                >
                                                    {point.toFixed(1)}
                                                </div>
                                            )
                                        )}
                                    </div>
                                </div>
                                <div className="grid">
                                    {performance.marks.last.length ? (
                                        performance.marks.last.map(
                                            (point, idx) => (
                                                <div
                                                    className="col-4 py-0 xs-col-6"
                                                    id={classNames({
                                                        first: idx <= 1,
                                                    })}
                                                    key={point.id}
                                                >
                                                    <div
                                                        className="area bg"
                                                        style={{
                                                            height: 152.233,
                                                        }}
                                                    >
                                                        <div className="title">
                                                            Получено
                                                        </div>
                                                        <div className="h1 dark">
                                                            {Math.floor(
                                                                point.mark
                                                            )}
                                                        </div>
                                                        <small className="date">
                                                            {_(point.date)}
                                                        </small>
                                                    </div>
                                                </div>
                                            )
                                        )
                                    ) : (
                                        <div
                                            className="col-4 py-0 xs-col-6"
                                            id="first"
                                        >
                                            <div
                                                className="area bg"
                                                style={{ height: 152.233 }}
                                            >
                                                <div className="title">
                                                    Пока нет оценок
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="lg:col-7 col-12 card py-0 md-mt-24">
                            <div className="header flex align-items-center justify-content-between homework-bg">
                                <div className="title">Домашнее задание</div>
                                <Link to="/homeworks/">
                                    <Button
                                        icon="pi pi-chevron-right white"
                                        className="p-button-rounded p-button-outlined"
                                    />
                                </Link>
                            </div>
                            <div className="content">
                                <div className="grid mt-0 h-full">
                                    <div
                                        className={
                                            (performance.homework.currentTask
                                                ? 'col-7'
                                                : 'col-12') +
                                            ' xs-col-12 py-0 relative'
                                        }
                                    >
                                        <div className="grid mt-0">
                                            <div className="col-6 py-0">
                                                <div
                                                    className="area bg"
                                                    style={{
                                                        height: 137.117,
                                                    }}
                                                >
                                                    <div className="title homework-text">
                                                        Всего
                                                        {addLineFeed ? (
                                                            <br />
                                                        ) : (
                                                            ' '
                                                        )}
                                                        заданий
                                                        <br />
                                                    </div>
                                                    <div className="h1 dark">
                                                        {
                                                            performance.homework
                                                                .total
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-6 py-0">
                                                <div
                                                    className="area bg"
                                                    style={{
                                                        height: 137.117,
                                                    }}
                                                >
                                                    <div className="title">
                                                        Текущие задания
                                                    </div>
                                                    <div className="h1 dark">
                                                        {
                                                            performance.homework
                                                                .upcoming
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="grid">
                                            <div className="col-6 py-0">
                                                <div
                                                    className="area bg"
                                                    style={{
                                                        height: 152.233,
                                                    }}
                                                >
                                                    <div className="title">
                                                        Просрочено заданий
                                                    </div>
                                                    <div className="h1 dark">
                                                        {
                                                            performance.homework
                                                                .expired
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-6 py-0">
                                                <div
                                                    className="area bg"
                                                    style={{
                                                        height: 152.233,
                                                    }}
                                                >
                                                    <div className="title">
                                                        Проверено заданий
                                                    </div>
                                                    <div className="h1 dark">
                                                        {
                                                            performance.homework
                                                                .completed
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {performance.homework.currentTask ? (
                                        <div className="col-5 xs-col-12 py-0">
                                            <div className="area overflow-y-scroll flex flex-column justify-content-between h-full">
                                                <div>
                                                    <div className="title light sm-mt-24">
                                                        Ближайшее
                                                    </div>
                                                    <div className="text bold fz-20">
                                                        {
                                                            performance.homework
                                                                .currentTask
                                                                .name
                                                        }
                                                    </div>
                                                    <small className="text">
                                                        {
                                                            performance.homework
                                                                .currentTask
                                                                .description
                                                        }
                                                    </small>
                                                    {/*TODO: ???? tags?*/}
                                                    <small className="text bold">
                                                        {
                                                            performance.homework
                                                                .currentTask
                                                                .name
                                                        }
                                                    </small>
                                                </div>
                                                <small className="text date">
                                                    До{' '}
                                                    {_(
                                                        performance.homework
                                                            .currentTask
                                                            .expiryAt
                                                    )}
                                                </small>
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="lg:col-4 col-12 card py-0">
                            <div className="header flex align-items-center justify-content-between materials-bg">
                                <div className="title">Учебные материалы</div>
                                <Link to="/materials/">
                                    <Button
                                        icon="pi pi-chevron-right white"
                                        className="p-button-rounded p-button-outlined"
                                    />
                                </Link>
                            </div>
                            <div className="content" style={{ height: 305.35 }}>
                                {performance.material ? (
                                    <div className="area flex flex-column justify-content-between h-full overflow-y-scroll">
                                        <div>
                                            <div className="flex justify-content-between">
                                                <div className="title materials-text">
                                                    Последнее поступление:
                                                </div>
                                            </div>
                                            <small className="date">
                                                {_(
                                                    performance.material
                                                        .createdAt
                                                )}
                                            </small>
                                            <div className="text fz-20 mt-6">
                                                {
                                                    performance.material.subject
                                                        .name
                                                }
                                            </div>
                                            <div className="text fz-20 bold mt-24">
                                                {formatMaterialName(
                                                    performance.material
                                                )}
                                            </div>
                                        </div>
                                        <small className="date mt-24">
                                            {'Урок'}
                                        </small>
                                    </div>
                                ) : (
                                    <div className="text fz-20">
                                        Здесь пока ничего нет
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="lg:col-4 col-12 card py-0 md-mt-24">
                            <div className="header flex align-items-center justify-content-between timetable-bg">
                                <div className="title">Расписание</div>
                                <Link to="/schedule/">
                                    <Button
                                        icon="pi pi-chevron-right white"
                                        className="p-button-rounded p-button-outlined"
                                    />
                                </Link>
                            </div>
                            <div className="content" style={{ height: 305.35 }}>
                                {performance.lesson ? (
                                    <div className="area overflow-y-scroll max-h-full">
                                        <div className="title timetable-text">
                                            Следующее занятие:
                                        </div>
                                        <div className="text fz-20 bold mt-6">
                                            {_(performance.lesson.time)}
                                            <br />
                                            {getTime(performance.lesson.time)}
                                        </div>
                                        <small className="date mt-24">
                                            Тема занятия:
                                        </small>
                                        <div className="text fz-20 bold mt-6">
                                            {performance.lesson.theme}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="text fz-20">
                                        Здесь пока ничего нет
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}
        </StudentLayout>
    );
};
